<template>
  <div>
    <label>Licensure Level</label>
    <div>
      <md-chip
        v-for="status in availableCodeStatuses"
        :key="status"
        class="tag"
        :class="{ 'md-primary': isSelected(status) }"
        :md-clickable="true"
        :md-disabled="readonly"
        @click="() => toggleCodeStatus(status)"
      >
        {{ status }}
      </md-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'patient-code-status',
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      availableCodeStatuses: [
        'Band 1',
        'Band 2',
        'Band 3',
        'Band 4',
        'Band 5',
        'Band 6',
        'Band 7',
        'Band 8',
        'APRN',
        'CNA',
        'LPN',
        'RN'
      ],
    };
  },
  computed: {
    caseConfCodeStatuses() {
      const { dispatch } = this.caseConf;
      if (!dispatch) {
        return [];
      }
      if (!dispatch.codeStatuses) {
        return [];
      }
      return dispatch.codeStatuses;
    },
  },
  methods: {
    isSelected(status) {
      return this.caseConfCodeStatuses.includes(status);
    },
    toggleCodeStatus(status) {
      if (this.isSelected(status)) {
        this.$emit('update', {
          dispatch: {
            codeStatuses: this.caseConfCodeStatuses.filter((s) => s !== status),
          },
        });
        return;
      }
      this.$emit('update', {
        dispatch: {
          codeStatuses: this.caseConfCodeStatuses.concat(status),
        },
      });
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  margin-bottom: 10px;
}

.md-chip.tag {
  display: inline-block;
  white-space: nowrap;
  margin: 5px 5px 5px 0;
  font-size: 16px;
}

.md-chip.md-disabled {
  cursor: not-allowed;
}
</style>